<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { RouterView } from 'vue-router'
import DefaultLayout from '@/layouts/default/views/DefaultLayout.vue'
import AuthLayout from '@/layouts/auth/views/AuthLayout.vue'
import { LAYOUTS } from '@/constants/layouts.constant'
import { useAppStore } from '@/app/store/app.store'
import Toaster from '@/components/base/toast/Toaster.vue'
import UnsavedChangesDialog from '@/components/common/UnsavedChangesDialog.vue'
import { App as AntApp, ConfigProvider } from 'ant-design-vue'
import { useAntTheme } from '@/app/theme/ant-theme'

const route = useRoute()

// Initialize store
useAppStore()
const { antLocale, antTheme } = useAntTheme()

const layout = computed(() => {
 const layoutName = route.meta.layout
 switch (layoutName) {
 case LAYOUTS.AUTH:
 return AuthLayout
 case LAYOUTS.DEFAULT:
 return DefaultLayout
 default:
 return null
 }
})
</script>

<template>
 <ConfigProvider :locale="antLocale" :theme="antTheme">
  <AntApp class="h-full">
   <component :is="layout">
    <RouterView />
   </component>
   <Toaster />
   <UnsavedChangesDialog />
  </AntApp>
 </ConfigProvider>
</template>
